import { StrapiActions, StrapiActionTypes, StrapiState } from "../../types/strapiVPO";

const initialState: StrapiState = {};

export const filtersDataVPO = (state = initialState, action: StrapiActions): StrapiState => {
  switch (action.type) {
    case StrapiActionTypes.FETCH_REQUEST_VPO: {
      const { modelName } = action.payload;
      return {
        ...state,
        [modelName]: {
          data: state[modelName]?.data || [],
          loading: true,
          error: null,
        },
      };
    }

    case StrapiActionTypes.FETCH_SUCCESS_VPO: {
      const { modelName, data, pagination } = action.payload;
      return {
        ...state,
        [modelName]: {
          data,
          loading: false,
          error: null,
          // lastAddedId: state[modelName]?.lastAddedId,
          // lastDocId: state[modelName]?.lastDocId,
          pagination,
        },
      };
    }

    case StrapiActionTypes.FETCH_FAILURE_VPO: {
      const { modelName, error } = action.payload;
      return {
        ...state,
        [modelName]: {
          data: state[modelName]?.data || [],
          loading: false,
          error,
        },
      };
    }

    default:
      return state;
  }
};
